import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'json-tree-view',
    template: `
    <div class="tree-node" [class.is-leaf]="IsLeaf()">
      <div class="node-header" (click)="Toggle()">
        <span class="toggle-icon" [class.expanded]="expanded">
          {{ IsLeaf() ? '📄' : (expanded ? '📂' : '📁') }}
        </span>
        <span class="node-key">{{ key }}</span>
        <span class="node-value">
          {{ value | jsontree }}
        </span>
      </div>
      <div class="node-children" *ngIf="!IsLeaf() && expanded">
        <json-tree-view
          *ngFor="let child of Children"
          [key]="child.key"
          [value]="child.value"
        ></json-tree-view>
      </div>
    </div>
  `,
    styles: [`
    .tree-node { margin-left: 1rem; }
    .node-header { cursor: pointer; padding: 0.2rem 0; display: flex; align-items: center; }
    .toggle-icon { margin-right: 0.4rem; }
    .node-key { font-weight: bold; margin-right: 0.4rem; }
    .node-value { color: #0066cc; }
    .node-children { margin-left: 1rem; }
  `],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class JSONTreeViewComponent {
    @Input() key: string = '';
    @Input() value: any;

    expanded = true;

    Toggle() {
        this.expanded = !this.expanded;
    }

    IsLeaf() {
        return typeof this.value !== 'object' || this.value === null;
    }

    get Children(): { key: string, value: any }[] {
        if (!this.value || typeof this.value !== 'object') return [];
        if (Array.isArray(this.value)) {
            return this.value.map((v, i) => ({ key: `[${i}]`, value: v }));
        }
        return Object.entries(this.value).map(([k, v]) => ({ key: k, value: v }));
    }
}